// extracted by mini-css-extract-plugin
export default {"mask-wrap":"mask-wrap-gIu19","mask-hide":"mask-hide-xh5TR","loading-content":"loading-content-Yv7Mm","text":"text-gse4M","maskfadein":"maskfadein-nia28"};